module.exports = __webpack_public_path__ + "img/test.fe2bd6e8.svg";